<!--
2023-06-02 ytw
-->
<template>
  <div class="pop-confirm">
    <div class="main-content" v-if="this.$store.state.internation == 'IN' || this.$store.state.internation == 'INT'">
      <div class="dailyFreeCashTop">
        <img :src="confirmBg" class="confirmBg"/>
        <img :src="betTable" class="betTable" v-if="confirmBtn===2">
        <img :src="rich" class="rich" v-if="confirmBtn!=2">
        <div class="brownDiv"><span :class="$t('lang.dailyFreeCash.brownFont')">{{brownText}}</span></div>
        <div class="yellowDiv textShadow" v-if="confirmBtn!=2">
          <p :class="$t('lang.dailyFreeCash.yellowFont')">{{$t('lang.dailyFreeCash.getExtra')}}</p>
          <p :class="$t('lang.dailyFreeCash.yellowFont')">{{$t('lang.account.currencyType')}}{{yellowText}} {{$t('lang.dailyFreeCash.now')}}</p>
        </div>
      </div>
      <div class="operation-row">
        <div class="operation-item">
          <div class="blue-btn-1" @click="doDeposit" v-if="confirmBtn!=2">
            <span>{{$t('lang.dailyFreeCash.btnDeposit')}}</span>
          </div>
          <div class="blue-btn-1" @click="play" v-if="confirmBtn===2">
            <span>{{$t('lang.dailyFreeCash.btnPlay')}}</span>
          </div>
        </div>
        <div class="operation-item" @click="close">
          <div class="green-btn-1">
            <span>{{$t('lang.dailyFreeCash.btnCancel')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import confirmBg from '@/assets/images/dailyFreeCash/confirmBg.webp'
import line from '@/assets/images/dailyFreeCash/line.png'
import betTable from '@/assets/images/dailyFreeCash/betTable.webp'
import rich from '@/assets/images/dailyFreeCash/rich.webp'
export default {
  name: 'dailyFreeCashConfirm',
  props: ['closeConfirm', 'closeAll', 'confirmBtn', 'brownText', 'yellowText'],
  data () {
    return {
      confirmBg,
      line,
      betTable,
      rich
    }
  },
  mounted () {

  },
  updated () {
  },
  watch: {

  },
  methods: {
    close () {
      this.closeConfirm()
    },
    play () {
      this.closeAll()
    },
    doDeposit () {
      this.closeAll()
      this.$router.push('/deposit')
    }
  }
}
</script>

<style lang="less" scoped>
.pop-confirm{
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.6);
  z-index: 990;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow: auto;
  background-position: bottom;
  background-origin: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
  @media screen and(max-height: 700px) {
    .confirmBg {
      width: 98%;
      margin: 50px 2px 0 2px;
      height: 450px;
      z-index: 10;
    }
    .line{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:37%;
      z-index: 50;
    }
    .betTable {
      width: 72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 40%;
    }
    .rich {
      width: 72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50%;
    }
    .brownDiv{
      width: 78.888vw;
      position: absolute;
      top: 32vh;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #4b2d2d;
    }
    .yellowDiv{
      width:100%;
      position: absolute;
      top:40%;
      left: 49.5%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #FFDE2F;
    }
    .fontBrownEn{
      font-size: 22px;
    }
    .fontBrownIn{
      font-size: 15px;
    }
    .fontYellowEn{
      font-size: 31px;
    }
    .fontYellowIn{
      font-size: 18px;
    }
  }
  @media screen and (min-height: 701px) and (max-height: 1000px) {
    .confirmBg {
      width: 98%;
      margin: 50px 2px 0 2px;
      z-index: 10;
    }
    .line{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:30%;
      z-index: 50;
    }
    .betTable{
      width:72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:32%;
    }
    .rich{
      width:72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:42%;
    }
    .brownDiv{
      width: 78.888vw;
      position: absolute;
      top:26vh;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #4b2d2d;
    }
    .fontBrownEn{
      font-size: 25px;
    }
    .fontBrownIn{
      font-size: 18px;
    }
    .fontYellowEn{
      font-size: 33px;
    }
    .fontYellowIn{
      font-size: 20px;
    }
    .yellowDiv{
      width:100%;
      position: absolute;
      top:33%;
      left: 49.6%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-size: 33px;
      font-weight: bolder;
      color: #FFDE2F;
/*      background: linear-gradient(to bottom,  #FFC300 18.06%, #FFF1C4 23.78%, #FFBF00 33.16%, #FFD458 66.49%, #FFEFC4 76.91%, #FFB900 84.72%, #FFCF55 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: bgp 6s infinite linear;*/
    }
  }
  @media screen and (min-height: 1001px)and (max-height: 1300px) {
    .confirmBg {
      width: 98%;
      height: 800px;
      margin: 50px 2px 0 2px;
      z-index: 10;
    }
    .line{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:32%;
      z-index: 50;
    }
    .betTable{
      width:72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:32%;
    }
    .rich{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:40%;
    }
    .brownDiv{
      width: 78.888vw;
      position: absolute;
      top:27vh;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #4b2d2d;
    }
    .yellowDiv{
      width:100%;
      position: absolute;
      top:34%;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #FFDE2F;
    }
    .fontBrownEn{
      font-size: 40px;
    }
    .fontBrownIn{
      font-size: 33px;
    }
    .fontYellowEn{
      font-size: 55px;
    }
    .fontYellowIn{
      font-size: 42px;
    }
  }
  @media screen and (min-height: 1301px) {
    .confirmBg {
      width: 98%;
      height: 1000px;
      margin: 50px 2px 0 2px;
      z-index: 10;
    }
    .line{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:32%;
      z-index: 50;
    }
    .betTable{
      width:72%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:32%;
    }
    .rich{
      width:70%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top:40%;
    }
    .brownDiv{
      width: 78.888vw;
      position: absolute;
      top:27vh;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #4b2d2d;
    }
    .yellowDiv{
      width:100%;
      position: absolute;
      top:34%;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-family: BerlinSansFB;
      font-weight: bolder;
      color: #FFDE2F;
    }
    .fontBrownEn{
      font-size: 40px;
    }
    .fontBrownIn{
      font-size: 33px;
    }
    .fontYellowEn{
      font-size: 55px;
    }
    .fontYellowIn{
      font-size: 42px;
    }
  }
  .main-content{
    width: 95%;
    align-self: center;
    .prompt-text{
      font-size: 16px;
      text-align: center;
      color: #F6D9AA;
      line-height: 25px;
    }
    .operation-row{
      display: flex;
      margin: 20px 0 0 0;
      justify-content: space-between;
      line-height: 6.081vh;
      padding: 0 0.5vw;
      .operation-item{
        text-align: center;
        width:46%;
        .blue-btn-1{
          background: #F6D9AA;
          width: 92%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          color: #000000;
          font-size: 2.837vh;
          font-weight: 700;
          letter-spacing: -0.05em;
          border-radius: 2.778vw;
        }
        .green-btn-1 {
          background: #F6D9AA;
          width: 92%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          color: #000000;
          font-size: 2.837vh;
          font-weight: 700;
          letter-spacing: -0.05em;
          border-radius: 2.778vw;
        }
      }
    }
  }
  .textShadow {
    text-shadow: 1px 1px 0 #4b2d2d,
    -1px 1px 0 #4b2d2d,
      1px -1px 0 #4b2d2d,
      -1px -1px 0 #4b2d2d,
    0px 1px 0 #4b2d2d,
      0px -1px 0 #4b2d2d,
    -1px 0px 0 #4b2d2d,
    1px 0px 0 #4b2d2d,
    2px 2px 0 #4b2d2d,
    -2px 2px 0 #4b2d2d,
      2px -2px 0 #4b2d2d,
      -2px -2px 0 #4b2d2d,
    0px 2px 0 #4b2d2d,
      0px -2px 0 #4b2d2d,
    -2px 0px 0 #4b2d2d,
    2px 0px 0 #4b2d2d,
    1px 2px 0 #4b2d2d,
    -1px 2px 0 #4b2d2d,
      1px -2px 0 #4b2d2d,
      -1px -2px 0 #4b2d2d,
    2px 1px 0 #4b2d2d,
    -2px 1px 0 #4b2d2d,
      2px -1px 0 #4b2d2d,
      -2px -1px 0 #4b2d2d;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DailyFreeCashConfirm/index.vue